import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var DummyLogger =
/*#__PURE__*/
function () {
  function DummyLogger() {
    _classCallCheck(this, DummyLogger);

    this.tag = '';
    this.description = '';
  }

  _createClass(DummyLogger, [{
    key: "matchesTag",
    value: function matchesTag() {
      return false;
    }
  }, {
    key: "setLevel",
    value: function setLevel() {}
  }, {
    key: "enable",
    value: function enable() {}
  }, {
    key: "disable",
    value: function disable() {}
  }, {
    key: "log",
    value: function log() {}
  }, {
    key: "debug",
    value: function debug() {}
  }, {
    key: "info",
    value: function info() {}
  }, {
    key: "warn",
    value: function warn() {}
  }, {
    key: "error",
    value: function error() {}
  }]);

  return DummyLogger;
}();